/**
 * @typedef {Object} LoadingManager
 *
 * @property {{PENDING:string,DONE:string,ABORTED:string}} STATES
 *
 * @property {function} subscribeHandler
 * @property {function} unsubscribeHandler
 *
 * @property {function} loadingPending
 * @property {function} loadingDone
 * @property {function} loadingAborted
 *
 */

(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'LoadingManager', [  LoadingManagerService ]);

    /**
     * Providing a model for application's loading progress.
     *
     * @returns {LoadingManager}
     */
    function LoadingManagerService(){

        /* ===== PRIVATE MEMBERS ============================================ */


        /** @enum */
        var LOADING_STATES = {
            PENDING:        'pending',
            DONE:           'done',
            ABORTED:        'aborted'
        }
        Object.freeze( LOADING_STATES );


        /** @type {enum} */
        var currentStatus = LOADING_STATES.PENDING;

        /** @type {Array<function(string)>} */
        var observerHandlers = [];





        /* ===== PUBLIC ATTRIBUTES ========================================== */


        /** @type {LoadingManager} */
        var service = {

            // Members
            STATES:         LOADING_STATES,

            isLoading:      true,


            // Methods
            loadingPending: loadingPending,
            loadingDone:    loadingDone,
            loadingAborted: loadingAborted,

            subscribeHandler:      subscribeHandler,
            unsubscribeHandler:    unsubscribeHandler
        };



        ////////////////////////////////////////////////////////////////////////

        return service; // Expose API

        ////////////////////////////////////////////////////////////////////////



        /* ===== PUBLIC METHODS ============================================= */


        function loadingPending() {
            if ( currentStatus === LOADING_STATES.PENDING ) return;

            notifyObservers( LOADING_STATES.PENDING );

            service.isLoading = true;
            currentStatus = LOADING_STATES.PENDING;
        }


        function loadingDone() {
            if ( currentStatus !== LOADING_STATES.PENDING ) return;

            notifyObservers( LOADING_STATES.DONE );

            service.isLoading = false;
            currentStatus = LOADING_STATES.DONE;
        }


        function loadingAborted() {
            if ( currentStatus !== LOADING_STATES.PENDING ) return;

            notifyObservers( LOADING_STATES.ABORTED );

            service.isLoading = false;
            currentStatus = LOADING_STATES.ABORTED;
        }


        /**
         * @param {function(string)} observer
         */
        function subscribeHandler( observer ) {
            observerHandlers.push( observer );
        }


        /**
         * @param {function(string)} observerHandler
         */
        function unsubscribeHandler( observerHandler ) {
            observerHandlers.filter( function( registeredObserverHandler ) {
                if ( observerHandler != registeredObserverHandler ) return registeredObserverHandler;
            });
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function notifyObservers( loadingStatus ) {
            observerHandlers.forEach( function( observersCallback ){
                observersCallback( loadingStatus );
            });
        }

    }
})();
